import { MyAccountSWR, MyAccountV2SWR } from '@sky-tv-group/shared';
import { kkService, myAccountService, myAccountV2Service } from './services';

export const myAccountSWR = new MyAccountSWR(myAccountService, kkService);
export const myAccountV2SWR = new MyAccountV2SWR(myAccountV2Service);
